var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grow-portfolio"
  }, /*#__PURE__*/React.createElement("path", {
    id: "$",
    d: "M12.9593 25V23.426C14.6402 23.151 15.5418 22.0049 15.5418 20.706C15.5418 19.346 14.7778 18.5208 13.0663 17.879C11.7674 17.3594 11.2173 17.0079 11.2173 16.3814C11.2173 15.8619 11.5993 15.3117 12.669 15.3117C13.7081 15.3117 14.3805 15.6632 14.7472 15.8313L15.1598 14.4254C14.6708 14.1809 14.0137 13.9517 13.051 13.9211V12.5H11.798V13.9976C10.2546 14.2726 9.33768 15.2812 9.33768 16.5954C9.33768 18.0165 10.3768 18.75 11.9813 19.3307C13.1121 19.7433 13.647 20.1864 13.647 20.8741C13.647 21.6076 12.9899 22.0813 12.0272 22.0813C11.095 22.0813 10.2393 21.7604 9.6433 21.4089L9.23071 22.8454C9.78084 23.2121 10.7435 23.4872 11.7063 23.5177V25H12.9593Z",
    fill: "#083844"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M41.6666 9.375H8.33325C6.60736 9.375 5.20825 10.7741 5.20825 12.5V37.5C5.20825 39.2259 6.60736 40.625 8.33325 40.625H41.6666C43.3925 40.625 44.7916 39.2259 44.7916 37.5V12.5C44.7916 10.7741 43.3925 9.375 41.6666 9.375Z",
    stroke: "#083844",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M38.9583 13.5416H38.1249C37.2044 13.5416 36.4583 14.2878 36.4583 15.2083V35.4166C36.4583 36.3371 37.2044 37.0833 38.1249 37.0833H38.9583C39.8787 37.0833 40.6249 36.3371 40.6249 35.4166V15.2083C40.6249 14.2878 39.8787 13.5416 38.9583 13.5416Z",
    fill: "#E8F7FF",
    stroke: "#083844",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy",
    d: "M30.625 22.9166H29.7917C28.8712 22.9166 28.125 23.6628 28.125 24.5833V34.7916C28.125 35.7121 28.8712 36.4583 29.7917 36.4583H30.625C31.5455 36.4583 32.2917 35.7121 32.2917 34.7916V24.5833C32.2917 23.6628 31.5455 22.9166 30.625 22.9166Z",
    fill: "#E8F7FF",
    stroke: "#083844",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-Copy-2",
    d: "M22.2915 28.125H21.4582C20.5377 28.125 19.7915 28.8712 19.7915 29.7917V34.7917C19.7915 35.7121 20.5377 36.4583 21.4582 36.4583H22.2915C23.212 36.4583 23.9582 35.7121 23.9582 34.7917V29.7917C23.9582 28.8712 23.212 28.125 22.2915 28.125Z",
    fill: "#E8F7FF",
    stroke: "#083844",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.dcd0cdcca2ac0efe28983dd2af953da4.svg";
export { ForwardRef as ReactComponent };